import GeneralConfigurationSimpleForm from './GeneralConfigurationSimpleForm'

export default GeneralConfigurationSimpleForm
